export const CLEAR_MEMBERSHIPS = "metabase/admin/people/CLEAR_MEMBERSHIPS";
export const STORE_TEMPORARY_PASSWORD =
  "metabase/admin/people/STORE_TEMPORARY_PASSWORD";
export const CLEAR_TEMPORARY_PASSWORD =
  "metabase/admin/people/CLEAR_TEMPORARY_PASSWORD";
